import { productActions } from '../../services';

export const productsReducer = ( state = {}, action ) => {
  if ( !action || !action.type || !action.code ) {
    return state;
  }
  let newState = {...state};
  switch ( action.type ) {
    case productActions.LOAD:     
      if( action.products ) {
        action.products.forEach( product => newState[product.name] = product );
      } else {
        newState[action.code] = action.product;
      } 

      return newState;
    case productActions.GET:
      delete newState[action.code];
      return newState;
    case productActions.RESET:
      return { products: {}};
    default:
      return state;
  }
};